/* BYAYA — look (21 oct 2026): the stone slots in the gemstone bar.

   byaya-stone-selector.js owns the choice: the drawer, the state, the
   photo. This script only draws what it chose into the bar that opens the
   drawer — one slot per stone, the swatch of the drawer with its month
   under it, or a "+" with "Pick a month" while a slot is still empty — so
   the product's whole point is visible before the drawer is opened. It reads
   the element's own `state`, `active` and `swatchUrl` and redraws whenever
   the bar's text or counter changes (the selector writes those on every
   change), on any change in the product form (the count option) and after
   a confirm. It never writes to the selector. Each slot carries data-pos:
   a tap on it opens the drawer at that stone (byaya-stone-selector.js,
   open). Styles: byaya-look.css, 3e.

   Every line in a slot stays one line (21 oct 2026, fit): on a 375px phone
   "BIRTHSTONE 1" broke as "BIRTHSTONE" over "1", and on a 360px phone
   "Pick a month" as "Pick a" over "month": three lines in one slot. When
   the words do not fit beside the stone, the row is set a little more
   compact, step by step: the captions smaller and closer (is-tight, then
   is-tighter), the month a size smaller (is-small); only when that is not
   enough do the slots put the stone over the words (is-stacked), as on a
   small phone. For the month the widest text the slot can ever show is
   measured ("Pick a month", "September", "Choose a color"), not the one on
   show, so the layout does not change while stones are picked, and the
   shop's longest words are measured too, so every product on the same phone
   gets the same layout (21 oct 2026, see REF_CAP). Again when the bar
   changes width and once the webfont is in. */
(function () {
  'use strict';

  function labelFor(cfg, key) {
    var items = cfg.items || [];
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].k === key) {
        if (items[i].l) return items[i].l;
        return String(items[i].v || '').split('-')[0];
      }
    }
    return '';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // the width a text takes, measured on the text itself (also where the
  // caption cuts it off)
  function textWidth(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    return range.getBoundingClientRect().width;
  }

  // the + of an empty slot: the BYAYA Line plus (snippets/byaya-icon.liquid),
  // rendered by snippets/byaya-stone-selector.liquid into a template
  // (29 oct 2026); a plain + if the template is not on the page
  function plusIcon() {
    var t = document.querySelector('template.byaya-icon-plus');
    return t ? t.innerHTML : '+';
  }

  // the room the words have: beside the stone, or under it when the slot
  // stands upright (three in a row, or is-stacked)
  function roomIn(slot) {
    var cs = getComputedStyle(slot);
    var w = slot.getBoundingClientRect().width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (cs.flexDirection === 'column') return w;
    var stone = slot.querySelector('.byaya-slot__stone');
    return w - (stone ? stone.getBoundingClientRect().width : 0) - (parseFloat(cs.columnGap) || 0);
  }

  // The same layout on every product (21 oct 2026). Each row used to be
  // measured on its own words only, so two rings with two stones could get
  // two layouts: "Choose a color" did not fit beside the stone where "Pick a
  // month" did, and the Eye Color Ring put its stones over the words (Aron).
  // Every row is now also measured on the longest words of the shop: the
  // caption "Birthstone 1", the hint "Pick a month" and the month
  // "September". So on one phone every product takes the same steps; a
  // product with an even longer word can only make its own row more compact.
  var REF_CAP = 'Birthstone 1', REF_HINT = 'Pick a month', REF_NAME = 'September';

  function capsFit(row) {
    var slots = row.querySelectorAll('.byaya-slot');
    for (var i = 0; i < slots.length; i += 1) {
      var cap = slots[i].querySelector('.byaya-slot__t small');
      if (cap && textWidth(cap) > roomIn(slots[i]) - 0.5) return false;
    }
    // the shop's longest caption, measured in the first slot and put back at
    // once (our own rows are skipped by the observer below)
    var first = slots[0] && slots[0].querySelector('.byaya-slot__t small');
    if (first) {
      var keep = first.textContent;
      first.textContent = REF_CAP;
      var w = textWidth(first);
      first.textContent = keep;
      if (w > roomIn(slots[0]) - 0.5) return false;
    }
    return true;
  }

  // the widest month a slot can show, in the font of the month: the hint
  // of an empty slot in the regular weight, a chosen name in medium, and the
  // shop's longest of each (above)
  var measure;
  function widestValue(cfg, val) {
    var cs = getComputedStyle(val);
    measure = measure || document.createElement('canvas').getContext('2d');
    var font = cs.fontSize + ' ' + cs.fontFamily;
    measure.font = '400 ' + font;
    var max = Math.max(measure.measureText(cfg.hintText || REF_HINT).width, measure.measureText(REF_HINT).width);
    measure.font = '500 ' + font;
    max = Math.max(max, measure.measureText(REF_NAME).width);
    (cfg.items || []).forEach(function (item) {
      max = Math.max(max, measure.measureText(item.l || String(item.v || '').split('-')[0]).width);
    });
    return max;
  }

  // beside the stone a month has one line; a slot that stands upright may
  // let a long one wrap (three in a row)
  function valsFit(row, cfg) {
    var slots = row.querySelectorAll('.byaya-slot');
    for (var i = 0; i < slots.length; i += 1) {
      if (getComputedStyle(slots[i]).flexDirection === 'column') continue;
      var val = slots[i].querySelector('.byaya-slot__t b');
      if (val && widestValue(cfg, val) > roomIn(slots[i]) - 0.5) return false;
    }
    return true;
  }

  function fitCaps(row) {
    var steps = ['is-tight', 'is-tighter'];
    row.classList.remove('is-tight', 'is-tighter');
    for (var i = 0; i < steps.length && !capsFit(row); i += 1) {
      if (i) row.classList.remove(steps[i - 1]);
      row.classList.add(steps[i]);
    }
  }

  function fit(row, cfg) {
    row.classList.remove('is-tight', 'is-tighter', 'is-small', 'is-stacked');
    if (!row.offsetWidth) return;
    if (!valsFit(row, cfg)) {
      row.classList.add('is-small');
      if (!valsFit(row, cfg)) {
        row.classList.remove('is-small');
        row.classList.add('is-stacked');
      }
    }
    fitCaps(row);
    if (!capsFit(row) && !row.classList.contains('is-stacked')) {
      row.classList.remove('is-small');
      row.classList.add('is-stacked');
      fitCaps(row);
    }
  }

  function init(el) {
    if (!el || el.__byayaSlots) return;
    var btn = el.querySelector('.byaya-ss__open');
    var cfgEl = el.querySelector('.byaya-ss__config');
    if (!btn || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var n = Number(cfg.stones) || 1;
    var row = document.createElement('span');
    row.className = 'byaya-slots';
    row.setAttribute('aria-hidden', 'true');
    btn.appendChild(row);
    btn.classList.add('has-slots');
    el.__byayaSlots = row;

    var last = '';
    function render() {
      var state = Array.isArray(el.state) ? el.state : [];
      var active = Math.max(1, Math.min(n, Number(el.active) || n));
      var html = '';
      for (var i = 0; i < active; i += 1) {
        var key = state[i];
        var set = !!key;
        var img = '';
        if (set && typeof el.swatchUrl === 'function') {
          try { img = el.swatchUrl(i, key); } catch (e) { img = ''; }
        }
        var small = (cfg.labels && cfg.labels[i]) ? cfg.labels[i] : (n > 1 ? 'Stone ' + (i + 1) : 'Stone');
        var big = set ? labelFor(cfg, key) : (cfg.hintText || 'Pick a month');
        html += '<span class="byaya-slot' + (set ? '' : ' byaya-slot--empty') + '" data-pos="' + i + '">' +
          '<span class="byaya-slot__stone"' + (img ? ' style="background-image:url(&quot;' + escapeHtml(img) + '&quot;)"' : '') + '>' + (set ? '' : plusIcon()) + '</span>' +
          '<span class="byaya-slot__t"><small>' + escapeHtml(small) + '</small><b>' + escapeHtml(big) + '</b></span></span>';
      }
      var sig = active + '|' + html;
      if (sig === last) return;
      last = sig;
      // the number of slots as an attribute: byaya-look.css (3e) lays the
      // slots out per number. Not as an inline style: the browser writes that
      // back as "--byaya-slot-n: 3", which a style selector does not match.
      row.setAttribute('data-n', String(active));
      row.innerHTML = html;
      fit(row, cfg);
    }

    render();
    // measured again when the bar changes width (a turned phone, a resized
    // window, a bar that was hidden) and once the webfont is in
    var lastW = -1;
    if (window.ResizeObserver) {
      new ResizeObserver(function (entries) {
        var w = Math.round(entries[0].contentRect.width);
        if (w === lastW) return;
        lastW = w;
        fit(row, cfg);
      }).observe(row);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(row, cfg); });
    // the selector writes the month names and the counter into the bar on
    // every change: that is the moment to redraw. Our own rows are skipped.
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i += 1) {
        if (!row.contains(records[i].target) || records[i].target === row.parentNode) { render(); return; }
      }
    });
    mo.observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style'] });
    var form = el.closest('form') || document;
    form.addEventListener('change', function () { setTimeout(render, 0); });
    el.addEventListener('click', function () { setTimeout(render, 50); setTimeout(render, 400); });
  }

  function boot() {
    var all = document.querySelectorAll('byaya-stone-selector');
    for (var i = 0; i < all.length; i += 1) init(all[i]);
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('byaya-stone-selector').then(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* BYAYA (21 oct 2026): the category chips at the top of a collection on a
   phone (sections/main-collection.liquid, byaya-look.css 5b2).
   - The row is the same on every collection and scrolls sideways when it is
     wider than the phone, so on the last categories (Earrings) the chip of
     the page you are on stood half outside the screen. On load the row is
     set so that chip is whole, with the page margin beside it, at once and
     without motion; a chip that is already whole leaves the row where it
     is. Once more when the webfont is in (it changes the width of the
     chips), unless the row has been touched by then.
   - A finger swipes the row (the browser's own scrolling), a mouse could
     not: in the phone view of the theme editor on a computer the row stood
     still (Aron, 21 oct). With a mouse the row now follows a drag, the way
     a finger moves it. A move of a few pixels or more is a drag and opens
     nothing; a plain click still opens the category. Touch and pen are
     left to the browser. */
(function () {
  'use strict';

  function show(row) {
    if (row.__byayaTouched) return;
    var cur = row.querySelector('.is-current');
    if (!cur || row.scrollWidth <= row.clientWidth) return;
    var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    var r = row.getBoundingClientRect();
    var c = cur.getBoundingClientRect();
    if (c.right > r.right - pad) row.scrollLeft += c.right - (r.right - pad);
    else if (c.left < r.left + pad) row.scrollLeft -= (r.left + pad) - c.left;
  }

  function touched() { this.__byayaTouched = true; }

  // the mouse drags the row (a finger already swipes it)
  function draggable(row) {
    var id = null, x0 = 0, left0 = 0, moved = false, swallow = false;
    function end() {
      if (id === null) return;
      id = null;
      if (!moved) return;
      moved = false;
      row.classList.remove('is-dragging');
      // the click that ends a drag opens nothing; it comes right after this
      swallow = true;
      setTimeout(function () { swallow = false; }, 0);
    }
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || row.scrollWidth <= row.clientWidth) return;
      id = e.pointerId; x0 = e.clientX; left0 = row.scrollLeft; moved = false;
    });
    row.addEventListener('pointermove', function (e) {
      if (id === null || e.pointerId !== id) return;
      if (!(e.buttons & 1)) { end(); return; }
      var dx = e.clientX - x0;
      if (!moved) {
        if (Math.abs(dx) < 5) return;
        moved = true;
        try { row.setPointerCapture(id); } catch (err) { /* the row follows while the mouse is over it */ }
        row.classList.add('is-dragging');
      }
      row.scrollLeft = left0 - dx;
    });
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('lostpointercapture', end);
    // a link is otherwise picked up and dragged as a link
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('click', function (e) {
      if (!swallow) return;
      swallow = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function boot() {
    var rows = document.querySelectorAll('.byaya-cats__row');
    for (var i = 0; i < rows.length; i += 1) {
      if (!rows[i].__byayaCats) {
        rows[i].__byayaCats = true;
        rows[i].addEventListener('pointerdown', touched, { passive: true });
        rows[i].addEventListener('wheel', touched, { passive: true });
        draggable(rows[i]);
      }
      show(rows[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(boot);
  // the theme editor draws a section anew after a change to its settings
  document.addEventListener('shopify:section:load', boot);
})();
